import React, { useContext } from "react";
import { Divider } from "antd";
import moment from "moment";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";

const ClientEscalationDetails = () => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const clientEscalationDetailsInfo =
    globalState?.eDetails && globalState?.eDetails;

  const clientEscalationDetails =
    clientEscalationDetailsInfo &&
    Object.keys(clientEscalationDetailsInfo)?.map((key) => ({
      key,
      value: clientEscalationDetailsInfo[key],
    }));

  clientEscalationDetails && clientEscalationDetails.forEach((item) => {});

  const keysToSkip = [
    "_id",
    "createdBy",
    "createdAt",
    "updatedBy",
    "updatedAt",
    "__v",
    "errorDescription",
    "errorInvestigationRemarks",
  ];

  const newClientEscalation = [
    {
      key: "disputeDetails",
      title: "Dispute Details",
      fields: [
        {
          key: "client",
          label: "Client",
        },
        {
          key: "clientSpocEmail",
          label: "Client SPOC Email",
        },
        {
          key: "empID",
          label: "Emp ID",
        },
        {
          key: "financialImpact",
          label: "Financial Impact",
        },
        {
          key: "agent",
          label: "Agent",
        },
        {
          key: "auditor",
          label: "Auditor",
        },
        {
          key: "reportingTl",
          label: "Reporting TL",
        },
        {
          key: "department",
          label: "Department",
        },
        {
          key: "process",
          label: "Process",
        },
        {
          key: "errorRaiseDate",
          label: "Error Raise Date",
        },
      ],
    },
    {
      key: "transactionDetails",
      title: "Transaction Details",
      fields: [
        {
          key: "transactionId",
          label: "Transaction ID",
        },
        {
          key: "transactionDate",
          label: "Transaction Date",
        },
      ],
    },
    {
      key: "errorDetails",
      title: "Error Details",
      fields: [
        {
          key: "errorArea",
          label: "Error Area",
        },
        {
          key: "errorType",
          label: "Error Type",
        },
        {
          key: "errorDescription",
          label: "Error Description",
        },
        {
          key: "errorInvestigationRemarks",
          label: "Error investigation remarks",
        },
        {
          key: "errorImpact",
          label: "Error Impact",
        },
        {
          key: "errorStatus",
          label: "Error Status",
        },
        {
          key: "dayoftheweek",
          label: "Day of the Week",
        },
        {
          key: "agentTenure",
          label: "Agent Tenure",
        },
        {
          key: "feedbackdate",
          label: "Feedback Date",
        },
        {
          key: "repeatedError",
          label: "Repeated Error",
        },
        {
          key: "correctiveActionTaken",
          label: "Corrective Action Taken",
        },
      ],
    },
    {
      key: "rcaDetails",
      title: "RCA Details",
      fields: [
        {
          key: "rcaLevelOne",
          label: "RCA Level One",
        },
        {
          key: "rcaLevelTwo",
          label: "RCA Level Two",
        },
        {
          key: "rcaLevelThree",
          label: "RCA Level Three",
        },
        {
          key: "rcaLevelFour",
          label: "RCA Level Four",
        },
      ],
    },
    {
      key: "timestamps",
      title: "Time Stamps",
      fields: [
        {
          key: "stage",
          label: "Stage",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "createdAt",
          label: "Created At",
        },
      ],
    },
  ];

  return (
    <>
      <div className="form-details-page">
        {newClientEscalation.map((section) => (
          <div key={section.key} className="form-section">
            <h2 className="form-section-title">{section.title}</h2>
            <div className="form-grid">
              {section.fields.map((field) => {
                const valueObj =
                  clientEscalationDetails &&
                  clientEscalationDetails?.find(
                    (item) => item.key === field.key
                  );
                let value = valueObj?.value ?? "";

                // Special: format dates
                const dateKeys = [
                  "errorRaiseDate",
                  "transactionDate",
                  "feedbackdate",
                  "createdAt",
                ];
                if (dateKeys.includes(field.key) && value && value !== "") {
                  value = new Date(value).toLocaleDateString();
                }

                // Special: nested user object
                if (field.key === "createdBy" && value && value.name) {
                  value = value.name;
                }

                return (
                  <div key={field.key} className="form-item">
                    <div className="form-label">{field.label}</div>
                    <div className="form-value">
                      {field.key === "stage" && (
                        <img
                          src={
                            value === "Completed"
                              ? "/audited.PNG"
                              : value === "Pending"
                              ? "/pending.png"
                              : value === "Accepted"
                              ? "/completed.png"
                              : "/disputed.png"
                          }
                          style={{ width: "17px" }}
                          alt="logo"
                        />
                      )}
                      {field.key === "errorImpact" && (
                        <img
                          src={
                            value === "HIGH"
                              ? "/high.png"
                              : value === "MEDIUM"
                              ? "/medium.png"
                              : "/low.png"
                          }
                          style={{ width: "17px" }}
                          alt="logo"
                        />
                      )}
                      {(field.key === "reportingTl" ||
                        field.key === "agent" ||
                        field.key === "auditor") &&
                        value && (
                          <img
                            className="auditProfileImage"
                            src={
                              process.env.REACT_APP_BACKEND +
                              "/images/dummy.jpg"
                            }
                            alt={value}
                          />
                        )}{" "}
                      {value || ""}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      {/* 
      <span className="text11 escalation-details-left">
        Client Escalation Details
      </span>
      {clientEscalationDetails &&
        clientEscalationDetails?.map((item) => {
          // Specify custom text for specific keys
          const customTextForKey = {
            clientSpocEmail: "Client SPOC Email",
            empID: "Emp ID",
            financialImpact: "Financial Impact",
            reportingTl: "Reporting TL",
            errorRaiseDate: "Error Raise Date",
            transactionId: "Transaction ID",
            transactionDuplicateReason: "Transaction Duplicate Reason",
            transactionDate: "Transaction Date",
            errorImpact: "Error Impact",
            errorArea: "Error Area",
            errorType: "Error Type",
            errorStatus: "Error Status",
            dayoftheweek: "Day of the week",
            agentTenure: "Agent Tenure",
            feedbackdate: "Feedback Date",
            repeatedError: "Repeated Error",
            correctiveActionTaken: "Corrective Action Taken",
            rcaLevelOne: "Rca Level One",
            rcaLevelTwo: "Rca Level Two",
            rcaLevelThree: "Rca Level Three",
            rcaLevelFour: "Rca Level Four",
            createdAt: "Created At",
          };

          // Check if the current key should be skipped
          if (keysToSkip.includes(item.key)) {
            return null; // Skip this iteration
          }

          return (
            <>
              {item.key !== "createdAt" && (
                <div
                  className="align-items-center d-flex justify-content-between mt-4"
                  key={item.key}
                >
                  <span className="text11 escalation-details-left color-grey">
                    {customTextForKey[item.key] ||
                      (item.key &&
                        item.key.charAt(0)?.toUpperCase() + item.key.slice(1))}
                  </span>
                  <span className="text11 escalation-details-left">
                    {item.key === "stage" && (
                      <img
                        src={
                          item.value === "Completed"
                            ? "/audited.PNG"
                            : item.value === "Pending"
                            ? "/pending.png"
                            : item.value === "Accepted"
                            ? "/completed.png"
                            : "/disputed.png"
                        }
                        style={{ width: "17px" }}
                        alt="logo"
                      />
                    )}{" "}
                    {item.key === "errorImpact" && (
                      <img
                        src={
                          item?.errorImpact === "HIGH"
                            ? "/high.png"
                            : item?.errorImpact === "MEDIUM"
                            ? "/medium.png"
                            : "/low.png"
                        }
                        style={{ width: "17px" }}
                        alt="logo"
                      />
                    )}{" "}
                    {(item.key === "reportingTl" ||
                      item.key === "agent" ||
                      item.key === "auditor") &&
                      item?.value?.name && (
                        <img
                          className="auditProfileImage"
                          src={
                            item?.value?.profilePicUrl
                              ? process.env.REACT_APP_BACKEND +
                                "/images/" +
                                item?.value?.profilePicUrl
                              : process.env.REACT_APP_BACKEND +
                                "/images/dummy.jpg"
                          }
                          alt={item?.value?.name}
                        />
                      )}{" "}
                    {item.key === "transactionDate" ||
                    item.key === "createdAt" ||
                    item.key === "errorRaiseDate" ? (
                      moment(item?.value).format("DD/MM/YYYY H:mm A")
                    ) : (
                      <>
                        {customTextForKey[item.key]?.name
                          ? customTextForKey[item.key]?.name
                          : customTextForKey[item.key]?.value ||
                            item?.value?.name
                          ? item?.value?.name
                          : item?.value}
                      </>
                    )}
                  </span>
                </div>
              )}
            </>
          );
        })}
      <Divider style={{ marginTop: "3px", zIndex: 1 }} />
      <span className="text11 escalation-details-left">Time Stamps</span>
      {clientEscalationDetails &&
        clientEscalationDetails.map((item) => {
          // Specify custom text for specific keys
          const customTextForKey = {
            createdAt: "Created At",
          };

          // Check if the current key should be skipped
          if (!keysToSkip.includes(item.key)) {
            return null; // Skip this iteration
          }

          return (
            <>
              {item.key === "createdAt" && (
                <div
                  className="align-items-center d-flex justify-content-between mt-4"
                  key={item?.key}
                >
                  <span className="text11 escalation-details-left color-grey">
                    {customTextForKey[item.key] ||
                      (item.key &&
                        item.key.charAt(0)?.toUpperCase() + item.key.slice(1))}
                  </span>
                  <span className="text11 escalation-details-left">
                    {item.key === "createdAt"
                      ? moment(item?.value).format("DD/MM/YYYY H:mm A")
                      : ""}
                  </span>
                </div>
              )}
            </>
          );
        })} */}
    </>
  );
};
export default ClientEscalationDetails;
